import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  FormFeedback,
} from "reactstrap";
import Modal from "react-bootstrap/Modal";
import {
  FaEnvelope,
  FaPaperPlane,
  FaEdit,
  FaTrash,
  FaEye,
  FaFilePdf,
  FaFileImage,
  FaPlus,
  FaPlusCircle,
  FaMinusCircle,
  FaSpinner,
} from "react-icons/fa";
import axios from "axios";
import { ServerAddress } from "../../../constants/ServerAddress";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { ColorRing } from "react-loader-spinner";
import toTitleCase from "../../../lib/titleCase/TitleCase";
import DateConvertor from "../../../components/dateConvertor/DateConvertor";
import TruncateWord from "../../../lib/truncateWords/TruncateWord";
// import { FaEnvelope, FaEye, FaEdit, FaTrash, FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
// import { useState } from 'react';

const MessageBox = () => {
  const accessToken = useSelector((state) => state.authentication.access_token);
  const user_info = useSelector((state) => state.authentication.userdetails);
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show_data, setshow_data] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [currentNotice, setCurrentNotice] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [viewNotice, setViewNotice] = useState(null);
  const [documents, setDocuments] = useState([[""]]);
  const [showTable, setShowTable] = useState(true);
  const [showNotice, setShowNotice] = useState(true);
  const [show_msg_loader, setshow_msg_loader] = useState(false);

  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [alldata, setalldata] = useState();
  const handleShow = () => {
    setShow(true);
  };

  console.log("documents------------>", documents);
  // Fetch all notices
  const fetchNotices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${ServerAddress}notice_board/get-Notice/?p=1&records=100`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setNotices(response.data.results);
    } catch (error) {
      console.error("Error fetching notices:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  // Form validation schema
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    status: Yup.string(),
    description: Yup.string(),
    comment: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      status: "",
      description: "",
      comment: "",
      date_of_expiry: "",
      attachment: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      await handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    setshow_msg_loader(true);
    try {
      await axios.post(
        ServerAddress + "notice_board/add-Notice/",
        {
          user: user_info.id,
          title: toTitleCase(values.title).toUpperCase(),
          description: values.description,
          date_of_expiry: values.date_of_expiry,
          status: values.status,
          comment: values.comment,
          attachment: documents,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      formik.resetForm();
      setDocuments([[""]]);
      fetchNotices();
      setshow_msg_loader(false);
    } catch (error) {
      setshow_msg_loader(false);
      console.error("Error submitting notice:", error);
    } finally {
      setshow_msg_loader(false);
    }
  };

  // Edit Notice
  const handleEdit = (notice) => {
    setshow_data(false);
    setCurrentNotice(notice);
    formik.setValues({
      title: notice.title,
      status: notice.status,
      description: notice.description,
      comment: notice.comment,
      date_of_expiry: notice.date_of_expiry,
    });
    setEditModal(true);
    // setDocuments(documents)
  };

  const updateNotice = () => {
    axios
      .put(
        ServerAddress + "notice_board/put-Notice/" + currentNotice.id,
        {
          ...formik.values,
          user: user_info.id,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        console.log("response==", response);
        if (response.data.status === "success") {
          setEditModal(false);
          setshow_data(true);
          fetchNotices();
          formik.setValues({
            title: "",
            status: "",
            description: "",
            comment: "",
            date_of_expiry: "",
          });
        } else {
          setshow_data(true);
        }
      })
      .catch((error) => {
        setEditModal(false);
      });
  };

  const deleteNotice = async (id) => {
    setLoading(true);
    try {
      await axios.post(
        ServerAddress + "notice_board/delete-Notice/",
        { data: [id] },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      fetchNotices();
    } catch (error) {
      console.error("Error deleting notice:", error);
    } finally {
      setLoading(false);
    }
  };

  // View Notice
  const handleView = (notice) => {
    setViewNotice(notice);
    setViewModal(true);
  };

  // Document handling functions
  const addDocument = () => {
    setDocuments([...documents, [""]]);
  };

  const deleteDocument = (index) => {
    if (documents.length > 1) {
      const updatedDocs = [...documents];
      updatedDocs.splice(index, 1);
      setDocuments(updatedDocs);
    }
  };

  const handleFileUpload = async (event, index) => {
    const file = event.target.files[0];

    if (
      file &&
      (file.type === "application/pdf" || file.type.startsWith("image/"))
    ) {
      try {
        const base64Url = await readFileAsBase64(file);
        const updatedDocs = [...documents];
        updatedDocs[index] = base64Url;
        updatedDocs[index][0] = base64Url;
        setDocuments(updatedDocs);
      } catch (error) {
        console.error("Error reading file:", error);
      }
    }
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  };
  return (
    <>
      {/* for delete  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this notice?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="btn btn-danger"
            onClick={() => deleteNotice(alldata.id)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* for view the notice */}
      <Modal
        show={viewModal}
        onHide={() => {
          setViewModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{viewNotice?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <strong>Posted on:</strong>{" "}
            {moment(viewNotice?.created_at).format("DD MMM YYYY hh:mm A")}
          </div>
          <div className="mb-3">
            <strong>Expires on:</strong>{" "}
            {viewNotice?.date_of_expiry
              ? moment(viewNotice.date_of_expiry).format("DD MMM YYYY")
              : "No expiry"}
          </div>
          <div className="mb-3">
            <strong>Description:</strong>
            <div className="p-2 bg-light rounded mt-1">
              {viewNotice?.description || "No description"}
            </div>
          </div>

          {/* Attachments Section */}
          {viewNotice?.attachment?.length > 0 ? (
            <div className="mb-3">
              <strong>AttachmentsView:</strong>
              <div
                className="d-flex flex-wrap gap-3 mt-2"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "#f9f9f9",
                }}
              >
                {viewNotice.attachment.map((doc, index) => {
                  const file = doc?.attachment_file;
                  if (!file) return null;

                  const isPDF = file.startsWith("data:application/pdf");
                  const isImage = file.startsWith("data:image");
                  const isDoc =
                    file.startsWith("data:application/msword") ||
                    file.startsWith(
                      "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    );
                  const isExcel =
                    file.startsWith("data:application/vnd.ms-excel") ||
                    file.startsWith(
                      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );

                  return (
                    <div
                      key={index}
                      className="text-center"
                      style={{ width: "150px" }}
                    >
                      {isImage ? (
                        <img
                          src={file}
                          alt={`Attachment ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                        />
                      ) : isPDF ? (
                        <a
                          href={file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block text-danger"
                          style={{
                            textDecoration: "none",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "6px",
                            background: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          📄 View PDF
                        </a>
                      ) : isDoc ? (
                        <a
                          href={file}
                          download={`document_${index + 1}.docx`}
                          className="d-block text-primary"
                          style={{
                            textDecoration: "none",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "6px",
                            background: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          📄 View Word
                        </a>
                      ) : isExcel ? (
                        <a
                          href={file}
                          download={`spreadsheet_${index + 1}.xlsx`}
                          className="d-block text-success"
                          style={{
                            textDecoration: "none",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "6px",
                            background: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          📊 View Excel
                        </a>
                      ) : (
                        <a
                          href={file}
                          download={`attachment_${index + 1}`}
                          className="d-block"
                          style={{
                            textDecoration: "none",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "6px",
                            background: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          📁 View Image
                        </a>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="text-muted">No attachments available.</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setViewModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* for the Edit  */}
      <Modal
        show={editModal}
        onHide={() => {
          setEditModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup>
              <Label>Title</Label>
              <Input
                type="text"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Description</Label>
              <Input
                type="textarea"
                name="description"
                value={formik.values.description}
                onChange={formik.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Expiry Date</Label>
              <Input
                type="date"
                name="date_of_expiry"
                value={formik.values.date_of_expiry}
                onChange={formik.handleChange}
              />
            </FormGroup>
    
            <FormGroup>
              <Label>AttachmentsUpdate</Label>
              {documents.map((doc, index) => (
                <div key={index} className="mb-3 d-flex align-items-center">
                  <Input
                    type="file"
                    name="date_of_expiry"
                    accept=".pdf, image/*"
                    onChange={(e) => handleFileUpload(e, index)}
                    className="mr-2"
                  />

                  {documents.length > 0 && (
                    <Button
                      color="danger m-2 "
                      size="sm"
                      onClick={() => deleteDocument(index)}
                    >
                      <FaTrash />
                    </Button>
                  )}
                </div>
              ))}
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setEditModal(false);
              setshow_data(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="btn btn-success"
            onClick={() => updateNotice()}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="row align-items-stretch">
        {/* Add New Notice */}
        <div className="col-12 col-md-6 d-flex">
          <Card
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #dcdcdc",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              marginBottom: "0",
              overflow: "hidden",
            }}
          >
            <CardHeader
              style={{
                backgroundColor: "#004085",
                color: "#fff",
                padding: "10px 16px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <CardTitle
                  tag="h6"
                  className="mb-0 d-flex align-items-center"
                  style={{ fontSize: "16px" }}
                >
                  <FaEnvelope className="me-2" /> Add New Notice
                </CardTitle>
                <button
                  onClick={() => setShowNotice((prev) => !prev)}
                  style={{
                    backgroundColor: "#fff",
                    color: "#004085",
                    border: "none",
                    padding: "6px",
                    borderRadius: "50%",
                    fontSize: "16px",
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  {showNotice ? <FaMinusCircle /> : <FaPlusCircle />}
                </button>
              </div>
            </CardHeader>
            {showNotice && (
              <CardBody>
                <Form
                  onSubmit={() => {
                    formik.handleSubmit();
                  }}
                >
                  <div className="row">
                    {/* Title */}
                    <div className="col-md-6  col-sm-6 mb-3">
                      <Label for="title" className="form-label">
                        Title <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        id="title"
                        name="title"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={show_data ? formik.values.title : ""}
                        invalid={formik.touched.title && !!formik.errors.title}
                      />
                      <FormFeedback>{formik.errors.title}</FormFeedback>
                    </div>

                    {/* Expiry Date */}
                    <div className="col-md-6 col-sm-6 mb-3">
                      <Label for="date_of_expiry" className="form-label">
                        Expiry Date
                      </Label>
                      <Input
                        type="date"
                        id="date_of_expiry"
                        name="date_of_expiry"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={show_data ? formik.values.date_of_expiry : ""}
                      />
                    </div>
                  </div>

                  {/* Description */}
                  <FormGroup className="mb-3">
                    <Label for="description">Description</Label>
                    <Input
                      type="textarea"
                      id="description"
                      name="description"
                      rows="2"
                      className="form-control"
                      onChange={formik.handleChange}
                      value={show_data ? formik.values.description : ""}
                    />
                  </FormGroup>

                  <FormGroup className="mb-2">
                    <Label>Add Attachments</Label>
                    {documents.map((doc, index) => (
                      <div
                        key={index}
                        className="mb-2 d-flex align-items-center gap-2"
                        style={{ padding: "6px 10px", borderRadius: "6px" }}
                      >
                        <Input
                          type="file"
                          accept=".pdf, image/*"
                          onChange={(e) => handleFileUpload(e, index)}
                          className="form-control me-2"
                        />

                        {documents.length > 1 && (
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => deleteDocument(index)}
                          >
                            <FaTrash />
                          </Button>
                        )}
                      </div>
                    ))}
                  </FormGroup>

                  <Button
                    type="btn"
                    color="primary"
                    className="d-flex align-items-center justify-content-center px-4 py-2"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{ minWidth: "150px" }}
                  >
                    {show_msg_loader && show_data ? (
                      <div className="d-flex align-items-center">
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                          style={{ width: "1rem", height: "1rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <FaPaperPlane className="me-2" />
                        Send Notice
                      </>
                    )}
                  </Button>
                </Form>
              </CardBody>
            )}
          </Card>
        </div>

        {/* Sent Notices */}
        <div className="col-12 col-md-6 d-flex">
          <Card
            className="w-100 d-flex flex-column shadow-sm"
            style={{
              height: "100%",
              border: "1px solid #dcdcdc",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <CardHeader
              style={{
                backgroundColor: "#004085",
                color: "#fff",
                padding: "10px 16px",
                borderBottom: "1px solid #ccc",
              }}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <CardTitle
                  tag="h6"
                  className="mb-0 d-flex align-items-center"
                  style={{ fontSize: "16px" }}
                >
                  <FaEnvelope className="me-2" /> Sent Notices ({notices.length}
                  )
                </CardTitle>
                <button
                  onClick={() => setShowTable((prev) => !prev)}
                  style={{
                    backgroundColor: "#fff",
                    color: "#004085",
                    border: "none",
                    padding: "6px",
                    borderRadius: "50%",
                    fontSize: "16px",
                    cursor: "pointer",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
                </button>
              </div>
            </CardHeader>

            {/* Table Body */}
            {showTable && (
              <CardBody
                className="d-flex flex-column p-0"
                style={{
                  backgroundColor: "#f8f9fa",
                  flex: "1 1 auto",
                  minHeight: "0",
                }}
              >
                <div
                  style={{
                    flex: "1 1 auto",
                    overflowY: "auto",
                    overflowX: "auto",
                  }}
                >
                  <table
                    className="table mb-0"
                    style={{
                      minWidth: "600px",
                      borderCollapse: "separate",
                      borderSpacing: "0 4px",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#dee2e6",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: "0",
                        zIndex: "1",
                      }}
                    >
                      <tr>
                        <th style={{ padding: "10px 12px" }}>Title</th>
                        <th style={{ padding: "10px 12px" }}>Description</th>
                        <th style={{ padding: "10px 12px" }}>Exp Date</th>
                        <th style={{ padding: "10px 12px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notices.map((notice, index) => (
                        <tr
                          key={notice.id}
                          style={{
                            backgroundColor: "#fff",
                            fontSize: "13px",
                            whiteSpace: "nowrap",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                            transition: "background-color 0.2s",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#f1f1f1")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor = "#fff")
                          }
                        >
                          <td style={{ padding: "4px" }}>
                            {
                              <TruncateWord
                                strng={toTitleCase(notice.title)}
                                charLimit={10}
                              />
                            }
                          </td>
                          <td style={{ padding: "4px" }}>
                            {
                              <TruncateWord
                                strng={notice.description}
                                charLimit={10}
                              />
                            }
                          </td>
                          <td style={{ padding: "4px" }}>
                            <DateConvertor inputDate={notice.date_of_expiry} />
                          </td>
                          <td style={{ padding: "4px" }}>
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => handleView(notice)}
                            >
                              <FaEye />
                            </Button>{" "}
                            {(user_info?.is_superuser ||
                              user_info.invitation_type === "ORGANIZATION" ||
                              // user_info.emp_department.some(
                              //   (item) => item.name === "HR"
                              // ) ||
                              user_info.id === notice.created_by) && (
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                  handleEdit(notice);
                                }}
                              >
                                <FaEdit />
                              </Button>
                            )}{" "}
                            {(user_info?.is_superuser ||
                              user_info.invitation_type === "ORGANIZATION" ||
                              // user_info.emp_department.some(
                              //   (item) => item.name === "HR"
                              // ) ||
                              user_info.id === notice.created_by) && (
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  handleShow(true);
                                  setalldata(notice);
                                }}
                              >
                                <FaTrash />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

export default MessageBox;
